import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ProcedureProtocol } from '../../../../project/modules/session-details-shared/session-details-shared-medical-record/interfaces/procedures';

@Component({
  selector: 'app-procedures-select-list',
  templateUrl: './procedures-select-list.component.html',
  styleUrls: ['./procedures-select-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProceduresSelectListComponent {
  @Input() public selectedProtocolObjects: ProcedureProtocol[] = [];
  @Input() public procedureType = 'APAC';

  @Output() public remove = new EventEmitter<{ procedureId: string; protocolId: string }>();

  public onRemoveProcedure(procedureId: string, protocolId: string): void {
    this.remove.emit({ procedureId, protocolId });
  }

  public trackByProtocolId(index: number, protocol: ProcedureProtocol): string {
    return protocol.id;
  }

  public trackByProcedureId(index: number, procedure: any): string {
    return procedure.id;
  }
}
